'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';
import Cookies, { CookieChangeListener } from 'universal-cookie';
import { TRACKING_COOKIE_NAME, TrackingCookieType } from './types';
import setUtmCookies from '@/middleware/utmParamsMiddleware/setUtmCookies';
const cookies = new Cookies();
function useTrackingCookie(serverSideCookieValue, domain) {
  const $ = _c(12);
  const [trackingCookieValue, setTrackingCookieValue] = useState(serverSideCookieValue);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cookie => {
      if (cookie.name !== TRACKING_COOKIE_NAME) {
        return;
      }
      setTrackingCookieValue(cookie.value as TrackingCookieType);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleCookieChange = t0;
  let t1;
  if ($[1] !== domain || $[2] !== searchParams) {
    t1 = value => {
      cookies.set(TRACKING_COOKIE_NAME, value, {
        path: "/",
        expires: new Date(2099, 1, 1),
        domain: `.${domain}`
      });
      setTrackingCookieValue(value);
      if (value !== "accepted" || !searchParams) {
        return;
      }
      setUtmCookies(cookies, domain, searchParams);
    };
    $[1] = domain;
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const setCookie = t1;
  let t2;
  let t3;
  if ($[4] !== setCookie) {
    t2 = () => {
      const value_0 = cookies.get(TRACKING_COOKIE_NAME) ?? null;
      if (value_0 && ["yes", "no", "accepted"].includes(value_0)) {
        cookies.remove(TRACKING_COOKIE_NAME, {
          path: "/"
        });
        if (value_0 === "no") {
          return;
        }
        setTimeout(() => setCookie("accepted"), 0);
      }
    };
    t3 = [setCookie];
    $[4] = setCookie;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const value_1 = cookies.get(TRACKING_COOKIE_NAME) ?? null;
      setTimeout(() => setTrackingCookieValue(value_1), 0);
      cookies.addChangeListener(handleCookieChange);
      return () => {
        cookies.removeChangeListener(handleCookieChange);
      };
    };
    t5 = [handleCookieChange];
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  if ($[9] !== setCookie || $[10] !== trackingCookieValue) {
    t6 = [trackingCookieValue, setCookie];
    $[9] = setCookie;
    $[10] = trackingCookieValue;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6 as const;
}
export default useTrackingCookie;